import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentTransportOrderEquipmentsFacade } from './shipment-transport-order-equipments.facade';
import { switchMap, take } from 'rxjs/operators';
import { TransportOrderIdView } from '../../../../models';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderEquipmentsGuard {
  constructor(
    private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade,
    private shipmentTransportOrderEquipmentsFacade: ShipmentTransportOrderEquipmentsFacade,
  ) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$.pipe(
      take(1),
      switchMap((identifier: TransportOrderIdView) =>
        loadStoreState(this.shipmentTransportOrderEquipmentsFacade, identifier),
      ),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderEquipmentsFacade);
  }
}
